<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-reclamations')">
            {{
            $t("page.reclamations")
            }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ active.order_number }}</a>
        </li>
      </ul>
    </nav>

    <nav class="panel">
      <div class="panel-heading">
        {{ $t('form.order_number') + ': '+ active.order_number }}
        <div class="is-pulled-right">
          <button
            class="button is-primary is-small"
            :class="{'is-loading': archiveLoading, 'is-info': active.archived}"
            @click="archive"
          >
            <i class="mdi mdi-package-up" v-if="active.archived"></i>
            <i class="mdi mdi-archive" v-else></i>
          </button>
        </div>
      </div>
      <div class="panel-block">
        <table class="table is-striped is-fullwidth">
          <tbody>
            <tr>
              <td>{{ $t("form.status") }}:</td>
              <td>{{ $t('form.' +active.status) }}</td>
            </tr>
            <tr>
              <td>{{ $t("form.order_id") }}:</td>
              <td>
                <nuxt-link
                  :to="localePath({ name: 'office-orders-id', params: { id: active.order_id }})"
                >{{ active.order_id }}</nuxt-link>
              </td>
            </tr>
            <tr>
              <td>{{ $t("form.company") }}:</td>
              <td>{{ active.company }}</td>
            </tr>
            <tr>
              <td>{{ $t("form.user") }}:</td>
              <td>
                <nuxt-link
                  :to="localePath({ name: 'office-users-id', params: { id: active.user_id }})"
                >{{ active.user_id }}</nuxt-link>
              </td>
            </tr>
            <tr>
              <td>{{ $t("form.date") }}:</td>
              <td>{{ active.created_at }}</td>
            </tr>
            <tr>
              <td>{{ $t("form.description") }}:</td>
              <td>{{ active.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </nav>
    <div class="is-clearfix">
      <div class="is-pulled-right" v-if="active.status === 'in_progress'">
        <button
          class="button is-primary"
          @click="update('accepted')"
          :class="{'is-loading': updateLoading === 'accepted'}"
          :disabled="updateLoading"
        >{{$t('form.accept')}}</button>
        <button
          class="button is-danger m-l-3"
          @click="update('rejected')"
          :class="{'is-loading': updateLoading === 'rejected'}"
          :disabled="updateLoading"
        >{{$t('form.reject')}}</button>
      </div>
      <div v-if="active.images.length">
        <vue-gallery :images="active.images" :index="index" @close="index = null"></vue-gallery>
        <div class="clearfix" style="margin: 0 -5px">
          <figure
            @click="index = i"
            class="image is-64x64"
            v-for="(image, i) in active.images"
            :key="i"
          >
            <img :src="image" />
          </figure>
        </div>
      </div>
    </div>

    <div class="m-t-5">
      <nuxt-child />
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  async asyncData({ store, params, error }) {
    try {
      await store.dispatch("reclamations/setActiveReclamation", params.id);
    } catch (e) {
      error(e);
    }
  },

  components: {
    VueGallery
  },

  data() {
    return {
      updateLoading: false,
      archiveLoading: false,
      index: null
    };
  },

  computed: {
    active() {
      return this.$store.state.reclamations.active;
    }
  },

  methods: {
    async update(status) {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.updateLoading = status;
        try {
          await this.$api.updateReclamationStatus(this.active.id, { status });

          this.$store.commit("reclamations/SET_ACTIVE", {
            ...this.active,
            status
          });
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        }

        this.updateLoading = false;
      }
    },

    async archive(status) {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.archiveLoading = status;
        try {
          await this.$api.archiveReclamation(this.active.id);
          await this.$store.dispatch('reclamations/setActiveReclamation', this.active.id);
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        } finally {
          this.archiveLoading = false;
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
.image {
  float: left;
  border: 1px solid #dbdbdb;
  background-color: lighten(#dbdbdb, 10%);
  margin: 5px;
  cursor: pointer;
  display: flex;

  img {
    margin: auto;
  }
}
</style>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/reclamations/_id.vue